module.exports = __webpack_public_path__ + "img/swiper5.78ec6ab7.jpg";